import Endpoint from "../../services/api/endpoint";
import { ICommunicationTemplate } from "../../utils/types/models";
import { createEntityReducer } from "./entityReducer";

export default createEntityReducer<ICommunicationTemplate>(Endpoint.CommunicationTemplates, Endpoint.CommunicationTemplatesList);